<script setup>
    import { useRouter } from 'vue-router';
    import { inject, onMounted, ref } from 'vue';
    import { useSharedFileStore } from '@/stores/file/sharedFileStore';
    import { useFileDownloadStore } from '@/stores/common/fileDownloadStore';
    import MainHeader from '@/components/HeaderComponent.vue';
    import { getCurrentInstance } from 'vue';

    import fileUploadDownloadService from '@/commonProject/service/fileUploadDownloadService';

    // Utis
    import utils from '@/commonProject/helpers/utils';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // ----------------------------
    // 定数
    // ----------------------------
    const router = useRouter();
    const sharedFileStore = useSharedFileStore();
    const fileDownloadStore = useFileDownloadStore();
    const app = getCurrentInstance();
    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const fileLists = ref([]);

    // ----------------------------
    // 関数
    // ----------------------------
    // 戻るボタン押下時
    function onBack() {
        router.back();
    }

    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        fileLists.value = {
            ShareFileCatLst: [
                {
                    ShareFileCatNm: '',
                    ShareFileLst: [
                        {
                            ShareFilePk: '',
                            ShareFileNm: '',
                            ShareFileExp: '',
                            ShareFileDldNm: '',
                        },
                    ],
                },
            ],
        };

        // リクエストボディを設定する。
        const requestBody = {};

        // 共有ファイル一覧APIをコールする。
        const response = await sharedFileStore.getSharedFileListFromApi(API_URL, requestBody);
        if (response.success) {
            fileLists.value = response.responseBody;
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    });

    async function fileDownload(shareFilePk, shareFileDldNm) {
        // リクエストボディを作成する。
        const requestBody = {
            ShareFilePk: shareFilePk,
        };
        // 共有ファイルダウンロードAPIをコールする。
        const response = await sharedFileStore.getSharedFilePrimaryKeyFromApi(API_URL, requestBody);
        if (response.success) {
            /*--- ダウンロード処理(修正前) - ここから ---*/
            /*
            const DldHistPk = response.responseBody.DldHistPk;
            if (!utils.isNullEmpty(DldHistPk)) {
                // クエリパラメーターを作成する。
                const queryParam = {
                    DldHistPk: DldHistPk, //ダウンロード履歴PK
                };

                let result = null;
                downloadCheck: do {
                    // ダウンロード履歴取得APIをコールする。
                    const response2 = await fileDownloadStore.getDownloadFileHistoryPkFromApi(API_URL, queryParam);
                    if (!response2.success) {
                        messageDialog('error', response2.errorMessage);
                        if (response2.redirect) {
                            location.href = response2.redirectUrl;
                        }
                    }

                    result = await fileUploadDownloadService.fileDownload(response2.responseBody.DldStatus, response2.responseBody.DldS3Url, shareFileDldNm);
                    switchByResult: switch (result) {
                        case 'startDownload':
                            {
                                const requestBody2 = {
                                    DldHistPk: DldHistPk,
                                    DldStatus: '3',
                                };
                                const response3 = await fileDownloadStore.updateDownloadFileHistoryPkFromApi(API_URL, requestBody2);
                                if (!response3.success) {
                                    messageDialog('error', response3.errorMessage);
                                    if (response3.redirect) {
                                        location.href = response3.redirectUrl;
                                    }
                                }
                                result = 'continue';
                            }
                            break switchByResult;
                        case 'endDownload':
                            {
                                const requestBody2 = {
                                    DldHistPk: DldHistPk,
                                    DldStatus: '4',
                                };
                                const response3 = await fileDownloadStore.updateDownloadFileHistoryPkFromApi(API_URL, requestBody2);
                                if (!response3.success) {
                                    messageDialog('error', response3.errorMessage);
                                    if (response3.redirect) {
                                        location.href = response3.redirectUrl;
                                    }
                                }
                                result = 'continue';
                            }
                            break switchByResult;
                        case 'error':
                            break downloadCheck;
                        case 'break':
                            break downloadCheck;
                        default:
                            continue downloadCheck;
                    }
                } while (result === 'continue');
            }
            */
            /*--- ダウンロード処理(修正前) - ここまで ---*/
            /*--- ダウンロード処理(修正後) - ここから ---*/
            const DldHistPk = response.responseBody.DldHistPk;
            if (!utils.isNullEmpty(DldHistPk)) {
                // ダウンロード履歴取得APIのクエリパラメーターを生成する。
                const queryParamDldHistGet = {
                    DldHistPk: DldHistPk, //ダウンロード履歴PK
                };

                // 念のためタイマーイベントを全てクリアする。
                // 万が一実行中のタイマーイベントが残っている場合は強制停止する。
                clearTimeout();

                // タイマーで監視し、APIのエラー時のループを制御する。
                let isDownloadTimeoutError = false;

                // ダウンロード処理開始後からダウンロード処理が完了せずに15分経過した場合は、エラーとしてダウンロード処理を停止する。
                const downloadTotalErrorTimer = 900000;

                // ダウンロード履歴取得APIをコールする間隔のタイマー値を設定する。
                // ダウンロード可能かどうかのチェック処理後、2秒間のインターバルを設けて、再度APIをコールする。
                const callDownloadHistoryApiintervalTimer = 2000;

                // ダウンロード対象のファイル名を宣言する。
                const fileName = shareFileDldNm;

                // ダウンロード処理の総経過時間を監視し、15分経過した場合に呼び出されるファンクションを宣言する。
                const checkTimeout = function () {
                    // ダウンロード総経過時間監視フラグを有効にして、ダウンロード限界時間経過としてエラー発生扱いにする。
                    isDownloadTimeoutError = true;

                    // 念のためタイマーイベントを全てクリアする。
                    // 万が一実行中のタイマーイベントが残っている場合は強制停止する。
                    clearTimeout();
                };

                // ダウンロード処理構造体を宣言する。
                // ダウンロード履歴取得API、ダウンロード履歴更新APIの実行タイミングを制御し、ダウンロード可能なファイルが存在する場合はJavascriptでダウンロードを実行する。
                const downloadEventPromise = async function (id) {
                    await new Promise(function (resolve, reject) {
                        // ダウンロード履歴取得APIから、ダウンロード対象ファイルの状態を取得し、本処理で判定して制御する。

                        // もし、ダウンロード総経過時間フラグが有効の場合は、以降の処理を実行せず、ダウンロード限界時間経過としてエラーにして、rejectで返却する。
                        if (isDownloadTimeoutError) {
                            reject('download timeout error');
                            return;
                        }

                        // ダウンロード履歴取得APIの判定したダウンロードファイルの状態に応じて制御する。
                        // ファイルダウンロード処理Javascript側で状況を判定している。
                        switch (id) {
                            case 'continue':
                            case 'startDownload':
                            case 'endDownload':
                                // ダウンロード準備中。
                                // ダウンロード可能状態の応答が返ってきた。
                                // Javascriptでファイルをダウンロードして、正常に完了した状態。
                                resolve(id);
                                break;
                            case 'error':
                            case 'break':
                            default:
                                // ダウンロード履歴取得APIでダウンロードエラーが発生。
                                // ダウンロード履歴取得APIからダウンロード完了が返却された場合。
                                // 上記以外の本処理内での例外の場合。
                                // ダウンロード処理を停止するためにrejectで返却する。
                                reject(id);
                                break;
                        }
                    })
                        .then(async function (resolved) {
                            // Promiseでresolveの正常応答の場合。

                            // もし、ダウンロード総経過時間フラグが有効の場合は、以降の処理を実行しない。
                            if (isDownloadTimeoutError) {
                                return;
                            }

                            // ダウンロード履歴取得APIから取得したステータスと、ダウンロード処理スクリプトで判定した結果に応じて制御する。
                            switch (resolved) {
                                case 'startDownload':
                                    {
                                        // ダウンロード履歴取得APIからダウンロード可能ステータスが返却されたので、Javascriptでファイルダウンロードを実行した場合。

                                        // ダウンロード履歴更新APIのリクエストボディを生成する。
                                        const requestBodyDldHistPut = {
                                            DldHistPk: DldHistPk,
                                            DldStatus: '3', // ダウンロード中モードに設定する。
                                        };

                                        // ダウンロード履歴更新APIをコールする。
                                        const responseDldHistPut = await fileDownloadStore.updateDownloadFileHistoryPkFromApi(API_URL, requestBodyDldHistPut);

                                        // APIの応答結果に応じて制御する。
                                        if (responseDldHistPut.success) {
                                            // APIの正常応答を検知して、再度本ダウンロードPromiseを実行する。
                                            await downloadEventPromise('continue');
                                        } else {
                                            // エラーの場合。
                                            messageDialog('error', responseDldHistPut.errorMessage);
                                            if (responseDldHistPut.redirect) {
                                                location.href = responseDldHistPut.redirectUrl;
                                            }
                                        }
                                    }
                                    break;
                                case 'endDownload':
                                    {
                                        // Javascriptでファイルダウンロードを実行した場合。

                                        // ダウンロード履歴更新APIのリクエストボディを生成する。
                                        const requestBodyDldHistPut = {
                                            DldHistPk: DldHistPk,
                                            DldStatus: '4', // ダウンロード完了に設定する。
                                        };

                                        // ダウンロード履歴更新APIをコールする。
                                        const responseDldHistPut = await fileDownloadStore.updateDownloadFileHistoryPkFromApi(API_URL, requestBodyDldHistPut);

                                        // APIの応答結果に応じて制御する。
                                        if (responseDldHistPut.success) {
                                            // APIの正常応答を検知して、再度本ダウンロードPromiseを実行する。
                                            await downloadEventPromise('continue');
                                        } else {
                                            // エラーの場合。
                                            messageDialog('error', responseDldHistPut.errorMessage);
                                            if (responseDldHistPut.redirect) {
                                                location.href = responseDldHistPut.redirectUrl;
                                            }
                                        }
                                    }
                                    break;
                                case 'continue':
                                    // ダウンロード履歴取得APIを指定のインターバルの時間経過後に再度コールするタイマーイベント。
                                    setTimeout(async function () {
                                        // ダウンロード履歴取得APIをコールする。
                                        const responseDldHistGet2 = await fileDownloadStore.getDownloadFileHistoryPkFromApi(API_URL, queryParamDldHistGet);

                                        // APIの応答結果に応じて制御する。
                                        if (responseDldHistGet2.success) {
                                            // ファイルダウンロードスクリプトを実行する。
                                            // ダウンロード履歴取得APIから取得したダウンロード状態、ダウンロードファイルの座標、ダウンロード対象のファイル名を引数に設定する。
                                            const fileUploadDownloadServiceResult2 = await fileUploadDownloadService.fileDownload(responseDldHistGet2.responseBody.DldStatus, responseDldHistGet2.responseBody.DldS3Url, fileName);

                                            // ファイルダウンロードスクリプト実行後、再度本ダウンロードPromiseを実行する。
                                            await downloadEventPromise(fileUploadDownloadServiceResult2);
                                        } else {
                                            // ダウンロード履歴取得APIがエラーの場合。
                                            messageDialog('error', responseDldHistGet2.errorMessage);
                                            if (responseDldHistGet2.redirect) {
                                                location.href = responseDldHistGet2.redirectUrl;
                                            }
                                        }
                                    }, callDownloadHistoryApiintervalTimer);
                                    break;
                                default:
                                    // 何もしない
                                    break;
                            }
                        })
                        .catch(function (/*rejected*/) {
                            // Promiseでrejectのルートで処理された場合。

                            // ダウンロードが完了した、や、エラーが発生したので、ダウンロード総経過時間フラグを更新して、以降の処理を実行しないようにする。
                            isDownloadTimeoutError = true;

                            // 念のためタイマーイベントを全てクリアする。
                            // 万が一実行中のタイマーイベントが残っている場合は強制停止する。
                            clearTimeout();
                        });
                };

                // ***** ダウンロードの初期処理を実行する - ここから - **** //

                // ダウンロード総時間を監視する。
                setTimeout(checkTimeout, downloadTotalErrorTimer);

                // 初回のダウンロード履歴取得APIをコールする。
                const responseDldHistGet = await fileDownloadStore.getDownloadFileHistoryPkFromApi(API_URL, queryParamDldHistGet);

                // APIの応答結果に応じて制御する。
                if (responseDldHistGet.success) {
                    // ファイルダウンロードスクリプトを実行する。
                    // ダウンロード履歴取得APIから取得したダウンロード状態、ダウンロードファイルの座標、ダウンロード対象のファイル名を引数に設定する。
                    const fileUploadDownloadServiceResult = await fileUploadDownloadService.fileDownload(responseDldHistGet.responseBody.DldStatus, responseDldHistGet.responseBody.DldS3Url, fileName);

                    // ファイルダウンロードスクリプト実行後、ファイルダウンロード処理Promiseを実行する。
                    await downloadEventPromise(fileUploadDownloadServiceResult);
                } else {
                    // ダウンロード履歴取得APIがエラーの場合。
                    messageDialog('error', responseDldHistGet.errorMessage);
                    if (responseDldHistGet.redirect) {
                        location.href = responseDldHistGet.redirectUrl;
                    }
                }

                // ***** ダウンロードの初期処理を実行する - ここまで - **** //
            }
            /*--- ダウンロード処理(修正後) - ここまで ---*/
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }
</script>

<template>
    <section id="main">
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <h3 class="textCenter noBorder">
                    <span>{{ $t('FileDownload.parts.pageTitle1') }}</span>
                </h3>
                <section class="whiteBoxContents">
                    <section id="fileDownload" class="form">
                        <article id="fileBox">
                            <template v-for="(data, index) in fileLists.ShareFileCatLst" :key="index">
                                <h4>{{ data.ShareFileCatNm }}</h4>
                                <hr class="dot" />
                                <article style="margin-bottom: 30px">
                                    <dl v-for="(data2, index2) in data.ShareFileLst" :key="index2" style="display: block">
                                        <dt style="width: 100%">
                                            <ul class="formLabel">
                                                <li>
                                                    <button type="button" class="textLink" @click="fileDownload(data2.ShareFilePk, data2.ShareFileDldNm)" style="text-align: left">{{ data2.ShareFileNm }}</button>
                                                </li>
                                            </ul>
                                        </dt>
                                        <dd>
                                            <ul class="formInput spKeepFlex">
                                                <li>
                                                    <span>{{ data2.ShareFileExp }}</span>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </article>
                            </template>
                        </article>
                    </section>
                </section>
                <section class="whiteBoxFooter">
                    <ul class="btnArea center">
                        <li>
                            <button type="button" id="btnBack" class="btnNormal" @click="onBack">{{ $t('FileDownload.parts.button1') }}</button>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>

<style></style>
